import axios from "axios";
import API from "../api";

export const ImagesModule = {
  state: {
    isRequesting: false,
    uploading: false,
    uploadProgress: 0,
    uploadTotal: 0,
    errored: false,
    error: ""
  },
  actions: {
    uploadGuestImage({
      commit
    }, { formData, guestId }) {
      guestId = guestId || 0;

      return new Promise(async (resolve, reject) => {
        commit("uploadImageRequest");
        return axios
          .post(`${API.BASE_URL}${API.GUESTS}${API.IMAGE}${guestId}`, formData, {
            headers: {Authorization: "Bearer " + API.TOKEN()},
            onUploadProgress: progressEvent => {
              commit('updateProgress', progressEvent)
            }
          })
          .then(response => {
            if (response.status === 200) {
              commit("uploadImageSuccess");

              if (guestId) {
                commit("updateContactSuccess", {
                  id: guestId,
                  photo_uri: response.data.photo_uri,
                  photo_md_uri: response.data.photo_md_uri,
                  photo_sm_uri: response.data.photo_sm_uri
                }, {
                  root: true
                });
              }
              resolve(response.data);
            } else {
              commit("imageError", response.data);
              reject(response.data);
            }
          })
          .catch(error => {
            commit("imageError", error);
            reject(error);
          });
      });
    },
    uploadItemImage({
      commit
    }, { formData, itemId }) {
      return new Promise(async (resolve, reject) => {
        commit("uploadImageRequest");
        return axios
          .post(`${API.BASE_URL}${API.ITEMS}${API.IMAGE}${itemId}`, formData, {
            headers: {Authorization: "Bearer " + API.TOKEN()},
            onUploadProgress: progressEvent => {
              commit('updateProgress', progressEvent)
            }
          })
          .then(response => {
            if (response.status === 200) {
              commit("uploadImageSuccess");
              commit("updateItemsSuccess", {
                id: itemId,
                image_uri: response.data.image_uri,
                image_md_uri: response.data.image_md_uri,
                image_sm_uri: response.data.image_sm_uri
              }, { root: true });
              resolve(response.data);
            } else {
              commit("imageError", response.data);
              reject(response.data);
            }
          })
          .catch(error => {
            commit("imageError", error);
            reject(error);
          });
      });
    },
  },
  mutations: {
    uploadImageRequest(state) {
      state.isRequesting = true;
      state.uploading = true
    },
    uploadImageSuccess(state) {
      state.uploading = false;
      state.uploadProgress = 0;
      state.uploadTotal = 0;
      state.isRequesting = false;
    },
    updateProgress(state, progress) {
      state.uploadProgress = progress.loaded
      state.uploadTotal = progress.total
    },
    imageError(state, error) {
      state.isRequesting = false;
      state.uploading = false;
      state.uploadProgress = 0;
      state.uploadTotal = 0;
      state.errored = true;
      state.error = error.message;
    }
  }
};